var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnarchive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "unarchive"
  }, /*#__PURE__*/React.createElement("path", {
    id: "lid",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 4H21V9H3V4ZM4.5 5.5V7.5H19.5V5.5H4.5Z",
    fill: "#727C8D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "box",
    d: "M4 9H5.5V18.5H18.5V9H20V20H4V9Z",
    fill: "#727C8D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "arrow",
    d: "M12 10.5L15 13.5H12.75V17H11.25V13.5H9L12 10.5Z",
    fill: "#727C8D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnarchive);
export default __webpack_public_path__ + "static/media/unarchive.611d3b49109afceb135787f278d7b740.svg";
export { ForwardRef as ReactComponent };